module.exports = __webpack_public_path__ + "static/start-4e0b9a704eec62811c87e51d7733c357.png";